import React from "react"
import { addressItem } from "../carnet-adresse.module.scss"
import PropTypes from "prop-types"
import AddressContent from "../AddressContent/address-content"

const RenderAddresses = ({ addressesData }) => {
  const addresses = addressesData.allNodeCarnetDAdresse.edges
  return (
    <>
      {addresses.map(({ node }) => (
        <div key={node.drupal_id} className={addressItem}>
          <AddressContent address={node} />
        </div>
      ))}
    </>
  )
}

RenderAddresses.propTypes = {
  addressesData: PropTypes.object.isRequired,
}

export default RenderAddresses
